export default __webpack_public_path__ + "static/media/IEEELoog-Black.538d2cc1.svg";